import { of, pipe } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { TimezoneService } from '../services';
import { State } from '../services/work.state';

export const setContactUtcOffset = (tzSvc: TimezoneService) =>
  pipe(
    switchMap(([state, currentState]: [Partial<State>, State]) => {
      if (state.master?.state || state.master?.country) {
        return tzSvc
          .getContactUTCOffset$(state.master?.state || '', state.master.country)
          .pipe(
            map((contactUtc) => ({
              ...state,
              ...{
                action: {
                  ...currentState.action,
                  ...state.action,
                  contactUtcOffset: contactUtc,
                },
              },
            })),
            map((state) => [state, currentState] as [Partial<State>, State])
          );
      } else {
        return of([state, currentState] as [Partial<State>, State]);
      }
    })
  );
